export default {
  header: {
    collection: '收藏',
    discord: '加入Discord',
    twitter: '关注Twitter',
  },
  landing: {
    discover: '发现',
    nodeRocks: 'NODE_ROCKS',
    onBitcoin: '在比特币上',
    searchPlaceholder: '输入Rock ID...',
    viewDetails: '查看详情',
  },
  story: {
    title: 'NodeRocks的背后故事',
    description: 'NodeRocks始于12月，由一位名为{{developer}}的开发者创建。然而，当项目面临潜在的跑路风险时，社区拒绝让它消亡。相反，他们团结在一起，接管了控制权，并开始从头重建项目。',
    community: '社区迅速获得了{{platform}}开发者门户的访问权限，并启动了新的社交媒体渠道以重新连接和成长。在短短几周内，NodeRocks变得比以往任何时候都更强大，社区开始构建令人兴奋的功能，如自己的质押平台、浏览器，甚至为项目创作音乐。',
    conclusion: 'NodeRocks现在是Ordinals空间中第一个100%由社区驱动的项目，这证明了充满激情的社区团结在一起推动项目达到新高度的力量。从几近崩溃到一个蓬勃发展、创新的社区，NodeRocks已成为比特币Ordinals世界中韧性和创造力的象征。',
  },
  yinYang: {
    title: '阴阳铭文',
    subtitle: '比特币上永恒的和谐象征',
    history: {
      title: '历史',
      description: '在诅咒铭文中，当{{positive}}和{{negative}}铭文链接到同一个中本聪时，出现了一个独特的现象。这种配对象征着二元性和和谐，灵感来自中国古代的阴阳哲学。',
    },
    rarity: {
      title: '阴阳铭文有多稀有？',
      description: '比特币上永远只有{{count}}个阴阳铭文，这使它们成为{{total}}个诅咒铭文中极其稀有的子集。它们的创建在2024年的{{block}}之后停止，巩固了它们的稀有性。',
    },
  },
  cursedRocks: {
    title: '诅咒岩石的二重性',
    subtitle: '比特币Ordinals的独特篇章',
    normal: '正常',
    cursed: '诅咒',
    hoverReveal: '悬停显示诅咒',
    whatAre: {
      title: '什么是诅咒岩石？',
      description: '每个NodeRock都配有其诅咒对应物，两者都唯一存储在同一个中本聪上。NodeRock代表正面铭文，而诅咒岩石则作为其负面对应物。它们共同形成完美的阴阳平衡，象征着二元性和相互联系。',
    },
    rarity: {
      title: '稀有度与价值',
      description: 'NodeRocks是第一个提供"买一送一"概念的收藏，每个NodeRock都配有其配对的诅咒岩石，形成阴阳平衡。仅创建了70,000个阴阳铭文，永远不会有新的阴阳铭文产生——这使每对都成为独特而稀有的资产。',
    },
  },
  laboratory: {
    title: '质押你的NODEROCKS！',
    stakeNow: '立即质押',
  },
  showcase: {
    title: '展示你的Rock',
    subtitle: '加入比特币上的数字艺术革命',
    viewCollection: '查看完整收藏',
  },
  footer: {
    language: '语言',
    selectLanguage: '选择语言',
    links: '快速链接',
    marketplace: 'Magic Eden市场',
    discord: '加入Discord',
    twitter: '关注Twitter',
    community: '社区',
    rights: '版权所有。',
  },
};